import {
  ONETRUST_SCRIPT_BASE_URL,
  ONETRUST_SCRIPT_NAME,
} from './onetrust.constants'

export function getOnetrustSdkSrc(scriptKey: string) {
  return [ONETRUST_SCRIPT_BASE_URL, scriptKey, ONETRUST_SCRIPT_NAME].join('/')
}
